// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a1c4d2e","455":"b07bdf49","488":"099a3302","977":"73a658f1"}[chunkId] + ".chunk.js";
};